import {Component, OnInit, ViewChild} from '@angular/core';
import {IonicModule, IonModal} from "@ionic/angular";
import {SharedModule} from "../../shared.module";
import {TranslatePipe} from "@ngx-translate/core";
import {DrawerModalComponent} from "../drawer-modal/drawer-modal.component";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormControlConverterPipe} from "../../pipe/form-control-converter.pipe";
import {SelectOption} from "../../model/select-option.model";
import {CommonService} from "../../service/common.service";
import * as _ from 'lodash';
import {CommonModule} from "@angular/common";
import {SimpleInputComponent} from "../simple-input/simple-input.component";
import {OutlinedInputComponent} from "../outlined-input/outlined-input.component";
import {UserService} from "../../service/user.service";

@Component({
  selector: 'app-contact-drawer',
  templateUrl: './contact-drawer.component.html',
  styleUrls: ['./contact-drawer.component.scss'],
  imports: [IonicModule, SharedModule, TranslatePipe, FormControlConverterPipe, CommonModule, SimpleInputComponent, OutlinedInputComponent],
  standalone: true
})
export class ContactDrawerComponent implements OnInit {

  @ViewChild('drawerModal') drawerModal!: DrawerModalComponent;
  @ViewChild('confirmModal') confirmModal!: DrawerModalComponent;

  sendingMessage: boolean = false;
  motivoOptions: SelectOption[] = [
    {
      label: 'Suggerimento',
      key: 'SUGGEST',
    },
    {
      label: 'Problema tecnico',
      key: 'ISSUE',
    },
    {
      label: 'Lavora con noi',
      key: 'CONNECT_WITH_US',
    }
  ];

  form: FormGroup = this.fb.group({
    motivo: new FormControl<string>('SUGGEST', [Validators.required]),
    message: new FormControl<string>(undefined, [Validators.required]),
    email: new FormControl<string>(undefined, [Validators.required])
  });

  constructor(private fb: FormBuilder,
              private userService: UserService,
              private commonService: CommonService) {
  }

  ngOnInit() {

    if (this.userService.user) {
      this.form.patchValue({
        email: this.userService?.user?.email,
      });
    }
  }

  open() {
    this.drawerModal.open();
  }

  close() {
    this.drawerModal.close();
  }

  closeConfirmModal() {
    this.confirmModal.close();
  }

  onSend() {
    this.sendingMessage = true;
    this.commonService.sendMessageToTelegram(
      'Motivo: ' + _.find(this.motivoOptions, item => item.key == this.form.value?.motivo)?.label +
      '\n\n\n' +
      'Email: ' + this.form.value?.email +
      '\n\n\n' +
      this.form.value.message
    ).subscribe(() => {

      setTimeout(() => {
        this.sendingMessage = false;
        this.close();
        this.confirmModal.open();
      }, 1200);


    });
  }

}
